import { render, staticRenderFns } from "./showEntrepreneurshipListAdmin.vue?vue&type=template&id=2565ff92"
import script from "./showEntrepreneurshipListAdmin.vue?vue&type=script&lang=js"
export * from "./showEntrepreneurshipListAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports